/**
 * @fileoverview API for student projects
 */
import { api } from 'helpers'

const BASE = '/api/arc_mosaico/students'

/** Response shape from API (all fields optional for safety) */
interface ProjectResponse {
  id?: string
  name?: string
  groupSchoolTerm?: { name?: string } | null
  grades?: Array<{ name?: string }>
  author?: { firstName?: string; lastName?: string }
}

interface ApiResponse {
  projects?: ProjectResponse[]
  pagination?: { count?: number; page?: number; pages?: number }
}

/** Fetches student projects by status. Never throws - returns safe defaults. */
export async function fetchStudentProjects(
  studentId: string,
  status: 'approved' | 'finished',
  page = 1,
  limit = 10
): Promise<{ projects: ProjectResponse[]; pagination: { count: number; page: number; pages: number } }> {
  try {
    const res = await api.get(`${BASE}/${studentId}/projects`, {
      params: { status, page, limit },
    })
    if (res.status === 401) {
      window.location.href = '/error_permission'
      return { projects: [], pagination: { count: 0, page: 1, pages: 1 } }
    }
    const data = (res.data ?? {}) as ApiResponse
    return {
      projects: Array.isArray(data.projects) ? data.projects : [],
      pagination: {
        count: data.pagination?.count ?? 0,
        page: data.pagination?.page ?? 1,
        pages: data.pagination?.pages ?? 1,
      },
    }
  } catch {
    return { projects: [], pagination: { count: 0, page: 1, pages: 1 } }
  }
}
